// @packages
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-native';
import { FieldValues, useForm } from 'react-hook-form';

// @scripts
import { View } from 'react-native';
import Button from '../../atoms/button';
import Input from '../../atoms/input';
import { config } from '../../../core/config';
import { routesOutLogged } from '../../../core/routes/config';
import { forgotPassword } from '../../../services/login-service';
import { useAuth } from '../../../core/context/provider';
import useStyles from './styles';

const ForgotPasswordForm = () => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { control, handleSubmit, setValue } = useForm();
  const { onUserForgotPassword, userForgotPassword } = useAuth();

  const onSubmit = async (data: FieldValues) => {
    try {
      setIsLoading(true);
      await forgotPassword(data.userName);
      onUserForgotPassword(data.userName);
      setIsLoading(false);
      navigate(routesOutLogged.forgotPasswordSendRecovery.path);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!userForgotPassword) return;

    setValue('userName', userForgotPassword);
  }, []);

  return (
    <View style={styles.container}>
      <Input
        control={control}
        leftIcon={{ name: 'person-outline', type: 'material' }}
        label={config.text.login.userNameLabel}
        name="userName"
        isRequired
        placeholder={config.text.login.userNamePlaceholder}
      />
      <Button
        isLoading={isLoading}
        color="secondary"
        title={config.text.loginForgotPassword.buttonSendRecovery}
        onClick={handleSubmit(onSubmit)}
      />
    </View>
  );
};

export default ForgotPasswordForm;
